import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { EStatus } from "../../../../../constants";
import { findFirst } from "../../../../../utils/arrays";
import { redirect } from "../../../../../utils/redirect";
import { getWindow } from "../../../../../utils/window";
import { getSmsCode, processSmsStatus } from "../../logic/utils";
import { getCommonParamsFromState } from "../../utils";
import { getIsSmsStatusReceived } from "../utils";
import { sendCardPayment as sendCardPaymentRBS } from "./api/index";
import { sendCardPayment } from "./api/index.legacy";
export var getSendCardPayment = function getSendCardPayment(_ref) {
  var getUserAccountInfo = _ref.getUserAccountInfo,
    getContent = _ref.getContent,
    isSmsResend = _ref.isSmsResend;
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(getState, setState) {
      var _getWindow$paymentTog, _getWindow;
      var state, _getUserAccountInfo, accountNumber, _getContent, loginUrl, paymentRBS, _ref3, isRbsEnabled, PAYMENT_RBS, _getCommonParamsFromS, from, isAuthenticated, sum, to, bindingId, orderDate, fn, status, isSmsStatusReceived;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            state = getState();
            _getUserAccountInfo = getUserAccountInfo(), accountNumber = _getUserAccountInfo.accountNumber;
            _getContent = getContent(), loginUrl = _getContent.loginUrl, paymentRBS = _getContent.paymentRBS;
            _ref3 = (_getWindow$paymentTog = (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : _getWindow.paymentToggles) !== null && _getWindow$paymentTog !== void 0 ? _getWindow$paymentTog : {}, isRbsEnabled = _ref3.isRbsEnabled;
            PAYMENT_RBS = isRbsEnabled !== null && isRbsEnabled !== void 0 ? isRbsEnabled : paymentRBS;
            _getCommonParamsFromS = getCommonParamsFromState(state, accountNumber !== null && accountNumber !== void 0 ? accountNumber : state.phoneInput.value, !!accountNumber), from = _getCommonParamsFromS.from, isAuthenticated = _getCommonParamsFromS.isAuthenticated, sum = _getCommonParamsFromS.sum, to = _getCommonParamsFromS.to, bindingId = _getCommonParamsFromS.bindingId;
            if (bindingId) {
              _context.next = 8;
              break;
            }
            throw new Error('no binding id found');
          case 8:
            if (isAuthenticated) {
              _context.next = 12;
              break;
            }
            _context.next = 11;
            return redirect(loginUrl, window);
          case 11:
            return _context.abrupt("return", EStatus.Processing);
          case 12:
            orderDate = new Date().toISOString();
            fn = findFirst([!PAYMENT_RBS && function () {
              return sendCardPayment({
                amount: sum,
                cardToken: bindingId,
                payee: to,
                payer: from,
                ofdAddress: from,
                smsCode: ''
              });
            }, function () {
              return sendCardPaymentRBS({
                loginData: {
                  isAuthenticated: isAuthenticated,
                  loginUrl: loginUrl
                },
                orderData: {
                  ctn: from,
                  orderDate: orderDate,
                  payeePhone: to,
                  sum: sum
                },
                bindingId: bindingId,
                smsCode: getSmsCode(state, !!isSmsResend)
              });
            }]);
            _context.next = 16;
            return fn === null || fn === void 0 ? void 0 : fn();
          case 16:
            status = _context.sent;
            isSmsStatusReceived = status && getIsSmsStatusReceived(status);
            if (!isSmsStatusReceived) {
              _context.next = 21;
              break;
            }
            processSmsStatus(setState, status);
            return _context.abrupt("return", undefined);
          case 21:
            return _context.abrupt("return", status);
          case 22:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};